import { Component, OnInit, AfterViewInit, Input, OnDestroy } from '@angular/core';

import { CommonMapService, LayersConfigByName } from './../../services/common-map.service';
import { LRSMap } from '../../../assets/TS/LRSMap_New';
import { SocketSidekickService } from 'app/services/socket-sidekick.service';

export interface MapParamsConfig {
	minReso?: number;
	reso?: number;
	center?: number[]
	minZoomLevel?: number
}

@Component({
	selector: 'app-common-map',
	templateUrl: './common-map.component.html',
	styleUrls: ['./common-map.component.css']
})
export class CommonMapComponent implements OnInit, AfterViewInit, OnDestroy {

	@Input() mapId: string;
	// ol layers by name
	@Input() layersConfig: LayersConfigByName;
	@Input() mapParamsConfig?: MapParamsConfig;
	@Input() mapMoveend: Function;
	@Input() mapPointermove: Function;

	zoomLevel: string;

	public map: LRSMap.Map;
	constructor(
		private mapService: CommonMapService,
		private socketSidekickService: SocketSidekickService
	) { }


	private updateZoomLevel() {
		this.zoomLevel = this.map.olMap.getView().getZoom().toFixed(1); // + '; reso: ' + this.mapService.map.olMap.getView().getResolution();
	}

	ngOnInit() {
	}
	ngAfterViewInit() {
		const mapParamsConfig: MapParamsConfig = this.mapParamsConfig || {};
		this.map = this.mapService.init(this.mapId, {
			layersConfig: this.layersConfig,
			onMapMoveend: (e) => {
				if (this.socketSidekickService.socketParam) {
					const ext = this.map.olMap.getView().calculateExtent(this.map.olMap.getSize());
					const transformedMin = this.mapService.mapUtility.transformProjection('POINT', [ext[0], ext[1]], this.mapService.mapProj, 'EPSG:4326');
					const transformedMax = this.mapService.mapUtility.transformProjection('POINT', [ext[2], ext[3]], this.mapService.mapProj, 'EPSG:4326');
					this.socketSidekickService.onSync({
						xmin: transformedMin[0],
						xmax: transformedMax[0],
						ymin: transformedMin[1],
						ymax: transformedMax[1]
					}, 'extent');
				}
				if (this.mapMoveend) {
					this.mapMoveend(e);
				}
			},
			onPointermove: this.mapPointermove,
			minReso: mapParamsConfig.minReso,
			resolution: mapParamsConfig.reso,
			center: mapParamsConfig.center
		});
		if (mapParamsConfig.minZoomLevel) {
			this.map.olMap.getView().setMinZoom(mapParamsConfig.minZoomLevel);
		}
		this.socketSidekickService.onInitMap();

		this.map.olMap.on('moveend', () => {
			this.updateZoomLevel();
		})
	}
	ngOnDestroy() {
		this.socketSidekickService.onDestroyMap();
	}
}
